/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search_icon': {
    width: 22,
    height: 22,
    viewBox: '0 0 22 22',
    data: '<path pid="0" _fill="#00CDFF" d="M15.714 13.829H14.71l-.378-.378c1.258-1.382 2.012-3.268 2.012-5.28A8.155 8.155 0 0 0 8.17 0 8.155 8.155 0 0 0 0 8.171a8.155 8.155 0 0 0 8.171 8.172c2.012 0 3.898-.754 5.28-2.012l.378.378v1.005L20.114 22 22 20.114l-6.286-6.285zm-7.543 0A5.634 5.634 0 0 1 2.514 8.17a5.634 5.634 0 0 1 5.657-5.657 5.634 5.634 0 0 1 5.658 5.657 5.634 5.634 0 0 1-5.659 5.66z"/>'
  }
})
